import React from 'react';
import { Dialpad } from '@material-ui/icons';
import FormConfigNumberField from '../../config/FormConfigNumberField';
import { FormNumberField } from '../../fields/FormNumberField';
export const FormNumberFieldPlugin = {
    icon: React.createElement(Dialpad, null),
    name: 'Number',
    type: 'NumberField',
    dataTypes: ['integer', 'numeric', 'text'],
    init: (type, _, previousElement) => ({
        type,
        dataType: 'number',
        title: (previousElement === null || previousElement === void 0 ? void 0 : previousElement.title) || 'Question',
        key: (previousElement === null || previousElement === void 0 ? void 0 : previousElement.key) || 'question'
    }),
    configurator: FormConfigNumberField,
    element: FormNumberField
};
//# sourceMappingURL=FormNumberFieldPlugin.js.map